import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import DismissButton from '../../../../components/global/DismissButton';
import WaldogramConfiguratorContainer from './WaldogramConfiguratorContainer';
import withModal from '../../../../components/global/modal/withModal';

export const WALDOGRAM_CONFIGURATOR_CONTAINER_MODAL =
  'modal/WALDOGRAM_CONFIGURATOR_CONTAINER';

const propTypes = {
  actionProps: PropTypes.shape({
    albumId: PropTypes.string,
    photoId: PropTypes.string,
  }),
  onRequestClose: PropTypes.func.isRequired,
};

const WaldogramConfiguratorContainerModal = ({
  actionProps,
  onRequestClose,
  ...props
}) => {
  const { albumId, photoId } = actionProps ?? {};

  return (
    <Fragment>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Kalam"
          rel="stylesheet"
        />
      </Helmet>

      <div className="wg-configurator-modal-wrap">
        <div className="wg-configurator-modal-header">
          <span className="wg-configurator-modal-title">Send a Card</span>
          <DismissButton onClick={onRequestClose} />
        </div>
        <div className="wg-waldogram-content-wrap">
          <WaldogramConfiguratorContainer
            albumId={albumId}
            photoId={photoId}
            {...props}
          />
        </div>
      </div>
    </Fragment>
  );
};

WaldogramConfiguratorContainerModal.propTypes = propTypes;

export default withModal(WaldogramConfiguratorContainerModal, {
  name: WALDOGRAM_CONFIGURATOR_CONTAINER_MODAL,
  dismissible: false,
  size: 'lg',
  type: 'full',
  hideHeader: true,
  shouldCloseOnOverlayClick: false,
  className: 'wg-configurator-modal',
});
